<!-- 支付结果 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="pay-state-ctn">
      <div class="pay-state" v-if="state == 0">
        <img src="../../../assets/images/success.png" alt />
        <span>恭喜您，支付成功！</span>
      </div>
      <div class="pay-state" v-else>
        <img src="../../../assets/images/fail.png" alt />
        <span>支付失败</span>
      </div>
      <div class="order-msg">
        <p>
          <span>订单号：</span>
          <span>{{orderInfo.osn}}</span>
        </p>
        <p>
          <span>订单金额：</span>
          <span>￥{{orderInfo.surplusMoney}}</span>
        </p>
      </div>
      <div class="gotoOrderDetails">
        <span @click="gotoOrderDetails" v-if="state == 0">订单详情</span>
        <span @click="gotoPay" v-else>重新支付</span>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    return {
      state: 0,
      osn: "",
      orderInfo: {}
    };
  },
  mounted() {
    this.osn = this.$route.query.osn;
    this.state = this.$route.query.state;
    this.getData();
  },
  methods: {
    gotoOrderDetails() {
      this.$router.push(`./orderDetails?OrderId=${this.orderInfo.oid}`);
    },
    gotoPay() {
      this.$router.push(`./pay?osn=${this.orderInfo.osn}`);
    },
    getData() {
      this.$util
        .axiosGet({
          url: "/api/Pay/GetPayPageInfo",
          data: {
            osn: this.osn
          }
        })
        .then(res => {
          let data = res.data;
          this.orderInfo = data;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.gotoOrderDetails {
  font-size: 18px;
  text-align: center;
  color: @theme;
  cursor: pointer;
  margin-top: 30px;
}
.pay-state-ctn {
  width: 1000px;
  margin: 0 auto;
}
.pay-state {
  margin-top: 80px;
  width: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 200;
  img {
    margin-right: 20px;
    width: 80px;
    height: 80px;
  }
}
.order-msg {
  width: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  p {
    line-height: 1.5em;
    width: 386px;
    font-size: 18px;
    font-weight: 200;
    display: flex;
    justify-content: space-between;
  }
}
</style>
